/**
 * API Logger - Logs which environment APIs are being used
 */

// Log the environment configuration on app startup
export const logEnvironmentInfo = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const wsUrl = process.env.REACT_APP_WS_URL;
  
  const isDev = apiUrl?.includes('development');
  const isProd = apiUrl?.includes('production');
  
  console.log('%c🚀 Environment Configuration', 'color: #4facfe; font-size: 16px; font-weight: bold;');
  console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #4facfe;');
  
  if (apiUrl) {
    console.log(
      `%c📡 API Base: %c${apiUrl}`,
      'color: #888; font-weight: bold;',
      isDev ? 'color: #667eea; font-weight: bold;' : 'color: #f5576c; font-weight: bold;'
    );
  } else {
    console.log(
      '%c📡 API Base: %cAuto-detect (localhost → DEV, S3 dev → DEV, default → PROD)',
      'color: #888; font-weight: bold;',
      'color: #4facfe;'
    );
  }
  
  if (wsUrl) {
    console.log(
      `%c🔌 WebSocket: %c${wsUrl}`,
      'color: #888; font-weight: bold;',
      isDev ? 'color: #667eea;' : 'color: #f5576c;'
    );
  }
  
  console.log(
    `%c🌍 Environment: %c${isDev ? 'DEVELOPMENT' : isProd ? 'PRODUCTION' : 'AUTO-DETECT'}`,
    'color: #888; font-weight: bold;',
    isDev ? 'color: #667eea; font-weight: bold; font-size: 14px;' : isProd ? 'color: #f5576c; font-weight: bold; font-size: 14px;' : 'color: #4facfe; font-weight: bold;'
  );
  
  console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #4facfe;');
  
  // Log detection logic
  if (!apiUrl) {
    const host = typeof window !== 'undefined' ? window.location.host : '';
    const isLocalhost = host.includes('localhost');
    const isDevSite = host.includes('saas-application-dev.s3-website');
    
    if (isLocalhost) {
      console.log('%c💻 Localhost detected → Using DEV endpoints', 'color: #667eea;');
    } else if (isDevSite) {
      console.log('%c☁️  Dev S3 site detected → Using DEV endpoints', 'color: #667eea;');
    } else {
      console.log('%c🏭 Production site → Using PROD endpoints', 'color: #f5576c;');
    }
  }
  
  console.log('%c ', 'font-size: 4px;'); // spacing
};

// Log API calls (optional - can be used in services)
export const logApiCall = (endpoint: string, method: string = 'GET') => {
  if (process.env.NODE_ENV === 'development') {
    console.log(
      `%c→ ${method} %c${endpoint}`,
      'color: #4facfe; font-weight: bold;',
      'color: #888;'
    );
  }
};

